import { useId } from 'react'
import { ClipPath, Defs, G, Path, Rect, Svg } from 'react-native-svg'

interface FlagIconProps {
    width?: number
    height?: number
}

/** United Kingdom — simplified Union Jack for small icon sizes. */
const UkFlagIcon = ({ width = 28, height = 20 }: FlagIconProps) => {
    const clipId = useId().replace(/:/g, '')

    return (
        <Svg width={width} height={height} viewBox="0 0 60 30">
            <Defs>
                <ClipPath id={clipId}>
                    <Rect width={60} height={30} />
                </ClipPath>
            </Defs>
            <G clipPath={`url(#${clipId})`}>
                <Rect width={60} height={30} fill="#012169" />
                <Path d="M0,0 L60,30 M60,0 L0,30" stroke="#FFFFFF" strokeWidth={6} />
                <Path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth={4} />
                <Path d="M30,0 V30 M0,15 H60" stroke="#FFFFFF" strokeWidth={10} />
                <Path d="M30,0 V30 M0,15 H60" stroke="#C8102E" strokeWidth={6} />
            </G>
        </Svg>
    )
}

export default UkFlagIcon
